import axios from './axios';
import config from '../../helpers/config';

export default (sessionId, designId) => (
  axios.delete(`${config.designBuilderApiBaseUrl}/sessions/${sessionId}/disassociate`, {
    params: { designId },
  })
);
